import { Component } from '@mycolorway/tao';
import { MDCMenuSurface, Corner } from '@material/menu-surface';
import $ from 'jquery';
import loading from 'simple-loading';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/projects/kanban/todolist-more-action.scss';

Component('tr-project-kanban-todolist-more-action', {
  mixins: [eventListenerMixin],

  properties: {
    todolistDetailSelector: String,
  },

  connected() {
    [this.anchor, this.menuSurface] = this.children;
    this.mdcMenuSurface = new MDCMenuSurface(this.menuSurface);
    this.mdcMenuSurface.setAnchorCorner(Corner.BOTTOM_LEFT);

    this.todolistDetail = document.querySelector(this.todolistDetailSelector);

    this.listenTo(this.anchor, 'click', () => {
      this.mdcMenuSurface.open = !this.mdcMenuSurface.open;
    });

    this.listenTo(this.mdcMenuSurface, {
      'MDCMenuSurface:closed': this.handleMenuSurfaceClosed.bind(this),
    });

    this.listenTo(this.menuSurface, 'click', this.handleMenuSurfaceClick.bind(this));

    $(this)
      .on(
        'ajax:success',
        '.mdc-list-item.link-toggle-archived',
        this.toggleArchived.bind(this),
      )
      .on(
        'ajax:beforeSend',
        '.todolist-copy-form',
        this.handleAsyncMessageBeforeSubmit.bind(this),
      )
      .on(
        'ajax:beforeSend',
        '.todolist-move-form',
        this.handleAsyncMessageBeforeSubmit.bind(this),
      )
      .on(
        'ajax:success',
        '.todolist-action-form',
        this.handleActionFormSubmitted.bind(this),
      );
  },

  handleMenuSurfaceClick(event) {
    const item = closest(event.target, '.mdc-list-item');
    if (item && item.dataset.action) {
      this.showActionForm(item.dataset.action);
      return;
    }

    const cancelButton = closest(event.target, '.form .button-cancel');
    if (cancelButton) {
      this.mdcMenuSurface.open = false;
    }
  },

  handleMenuSurfaceClosed() {
    this.menuSurface.classList.remove('show-action-form');
    if (this.currentActionForm) {
      this.menuSurface.removeChild(this.currentActionForm);
      this.currentActionForm = null;
    }
  },

  toggleArchived() {
    window.tower.stack.load(window.location.href, { replace: true, fluid: true });
  },

  handleAsyncMessageBeforeSubmit(event) {
    if (!event.target.dataset.asyncMessage) return;

    this.mdcMenuSurface.open = false;
    loading({
      type: 'global',
      msg: event.target.dataset.asyncMessage,
    });
  },

  handleActionFormSubmitted(event, result) {
    const { action } = event.target.dataset;

    this.mdcMenuSurface.open = false;
    loading.destroy();

    if (action === 'copy') {
      this.todolistDetail.showCopiedMessage({
        projectName: result.proj_name,
        todolistUrl: result.kanbanTodolistUrl,
      });
    } else if (action === 'move') {
      this.todolistDetail.showMovedMessage({
        projectName: result.proj_name,
        todolistUrl: result.kanbanTodolistUrl,
      });
    }
  },

  showActionForm(action) {
    const template = this.querySelector(`#tpl-todolist-${action}-form`);

    this.currentActionForm = document
      .importNode(template.content, true).firstElementChild;
    this.menuSurface.appendChild(this.currentActionForm);
    this.menuSurface.classList.add('show-action-form');
  },

  disconnected() {
    this.stopListening();
    $(this).off();
  },
});
